import React, {useContext, useRef} from 'react';
import {GisContext} from "../context/gis-context.jsx";
import GisUtils from "../utils/gis-utils.jsx";
import {FaGear, FaMagnifyingGlass} from "react-icons/fa6";

const GisMenu = ({handleDetails, toggleConfig, configIsOpen, toggleGeocoding, geocodingIsOpen, eventsCount}) => {
    const {target, menu, sentryGrid} = useContext(GisContext);

    const group = useRef(undefined);

    return (
        <>
            <div className={`sidenav ${sentryGrid ? "hidden" : ""}`} data-mdb-hidden={false}>
                <ul id="#scroll-container" className="sidenav-menu mt-1">
                    {
                        Object.keys(menu).filter(key=> menu[key].showInMenu).map((key, i) => {
                            const breakLine = i > 0 && group.current && group.current !== menu[key].group;
                            group.current = menu[key].group;

                            return (
                                <React.Fragment key={key}>
                                    {
                                        breakLine &&
                                        <li>
                                            <hr className="mt-1 mb-1 text-[#bdbdbd]"/>
                                        </li>
                                    }
                                    <li className={"sidenav-item" + (target.selected === key ? " selected" : "")}
                                        title={GisUtils.getGroupName(key)}>
                                        <div className={"sidenav-link" + (eventsCount[key] > 0 ? " alert-blink" : "")} onClick={() => handleDetails(key, null)}>
                                            {GisUtils.getGroupIcon(key)}
                                        </div>
                                    </li>
                                </React.Fragment>
                            )
                        })
                    }

                    <li className={"sidenav-item" + (geocodingIsOpen ? " selected" : "")} title="Endereço">
                        <div className="sidenav-link" onClick={toggleGeocoding}>
                            <FaMagnifyingGlass className={"sw"}/>
                        </div>
                    </li>

                    <li>
                        <hr className="my-1 text-[#bdbdbd]"/>
                    </li>

                    <li className={"sidenav-item" + (configIsOpen ? " selected" : "")} title="Configurações">
                        <div className="sidenav-link" onClick={toggleConfig}>
                            <FaGear className={"sw"}/>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default GisMenu;